const doc = [({"en":({"js":({"competitions":({"choose_team_type":({"grade":"Grade %{class_name}", "start_individually":"Play as individual", "start_team":"Play as team"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;